// Social Bar
// see "SocialBar.spec.js" and "SocialBar.less" file for more details
import TrackingUtils from '../../components/fsUtils/TrackingUtils';

class SocialBar {

  constructor(bar){

    var that = this;

    that.htmlString = `<div class="socialBar-container">
    <span class="socialBar-commentCount"></span>
    <span class="socialBar-shares">
    <span></span>
    </span>
    </div>
    <div class="socialBar-popover">
    <a class="icon icon-FS_Icons_collapse close"></a>
    <div class="socialBar-popover-container"></div>
    </div>`;

    that.shareProxyUrl = (function(hostName) {
      switch(hostName){
        case 'www.foxsports.com':
          return 'http://svcs.foxsports.com/socialweb/socialproxy/url';
        default:
          return 'http://preprod.svcs.foxsports.com/socialweb/socialproxy/url';
      }
    }(window.location.hostname));

    that.currentDomain = window.location.host;
    if (typeof bar !== 'undefined') {
      that.target = bar;
      that.options = JSON.parse(bar.getAttribute('data-social-bar'));

      if (that.target.children.length > 0) {
        for (var child in that.target.children) {
          if (typeof that.target.children[child].className !== 'undefined') {
            that.target.content = that.target.children[child];
          }
        }
        // set up basic functionalities
        if (typeof that.options !== 'undefined' &&
          typeof that.options.url !== 'undefined' &&
          typeof that.target.content !== 'undefined') {
          var wrapper = that.target.content,
            sharesTag;
          for (var i = wrapper.children.length;i--;) {
            var child = wrapper.children[i];
            if (typeof child.className !== 'undefined') {
                // set up share count
                if (child.className.indexOf('shares') > 0) sharesTag = child;
                // set up popover toggle
                if (child.className.indexOf('popover-trigger') > 0 &&
                  child.children.length > 0 &&
                  typeof child.children[0].className !== 'undefined') {
                  child.addEventListener('click', that.togglePopover, false);
                  child.children[0].setAttribute('style', 'visibility:hidden;opacity:0;');
              }
            }
          }

          // get social count
          // that.getSocialCounts(that.options.url, {
          //   mainTag: bar,
          //   sharesTag: sharesTag
          // });
        }
        // 
        var descendants = that.target.content.getElementsByTagName("*");
        for (var descendant in descendants) {
          if (typeof descendants[descendant].hasAttribute !== "undefined" && descendants[descendant].hasAttribute("href")) {
            descendants[descendant].addEventListener("click", function(ev) {
              if(typeof ev.preventDefault !== 'undefined') ev.preventDefault();
                // FSCOM-7938 if(typeof ev.stopPropagation !== 'undefined') ev.stopPropagation();

              var target = ev.currentTarget || ev.srcElement || ev.target;
              // trigger opening link to a new window (window.open - https://developer.mozilla.org/en-US/docs/Web/API/Window/open) 

              window.open(target.getAttribute('href'),'_blank');

              // set tracking for social link (*TEMP* DISABLED)
              that.trackLink(target);
              }, false);
          }
        }
        that.target.setAttribute('data-social-bar-loadState', '');
      }
    }
  }

  //functions
  // SHARES/COMMENTS COUNTING FUNCTIONS
  // get the data of the social counts for the page
  getSocialCounts(url, opts) {
    // use "that" as namespace to call other socialBar functions 
    var that = this;
    // set variables
    var shareUrl = url || that.options.url;

    if((shareUrl.indexOf('http://') < 0) && (shareUrl.indexOf(that.currentDomain) < 0)) shareUrl = 'http://'+that.currentDomain+shareUrl;

    var shareProxyUrl = that.shareProxyUrl + '?url=' + shareUrl;

    that.runXHR(shareProxyUrl, that.processData, opts, that);
    window.setInterval(function(){
      runXHR(shareProxyUrl, that.processData, opts, that);
    },420000);

    return that;
  }

  // processData
  // process returned value from runXHR (externalized for unit testing)
  // * @data - passed value(object) from XHR
  // * @opts - config options for processing passed value
  // * @context - function reference for retaining context to run specific functions (printSharedCounts) or assign context-tied values (socialCounts)

  processData(data, opts, context) {
    context = context || this;

    if(data !== null) {
      var result = (typeof data === 'object') ? data : JSON.parse(data);

      context.socialCounts = result;

      if (opts && opts.sharesTag) {
        return context.printSharesCount(opts.sharesTag, result.totalSocialCount);
      } else {
        return result;
      }
    } else {
      if (opts && opts.sharesTag) {
        return context.printSharesCount(opts.sharesTag);
      } 
    }
  }

  // runXHR
  // XHR function (vanilla JS)
  // * @url - full url path
  // * @cb - passed callback function to run once a successful response is received
  // * @opts - part of callback params, config object for callback's use
  // * @context - function reference for retaining context to run specific functions or assign context-tied values
  //
  // NOTE: transfering to fsUtils when ready.

  runXHR(url, cb, opts, context) {
    context = context || this;
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4){
        if(xhr.status == 200) {
          cb(xhr.responseText, opts, context);
        } else {
          cb(null, opts, context);
        }
      } 
    }
    xhr.open('GET', url, true);
    xhr.send();
  }

  // print out the total number of shares of the target page
  printSharesCount(target, count) {
    let el = target;
    let sharesCount = 0;

    if (count) {
      sharesCount = count;
    } else if (typeof this.socialCounts !== 'undefined') {
      sharesCount = this.socialCounts.totalSocialCount;
    }

    if(sharesCount >= 1000000) {
      el.innerHTML = "<span>" + Math.round(sharesCount / 1000000) + "M</span>shares";
    } else if (sharesCount >= 1000){
      el.innerHTML = "<span>" + Math.round(sharesCount / 1000) + "K</span>shares";
    } else {
      el.innerHTML = "<span>" + sharesCount + "</span>shares";
    }

    return el;
  }
  // POPOVER FUNCTIONS
  togglePopover(ev) {
    if (ev) {
      var trigger = ev.target || ev.srcElement;

      function hideTarget(target) {
        target.style.visibility = "hidden";
        target.style.opacity = "0";
      }

      function showTarget(target) {
        target.style.visibility = "visible";
        target.style.opacity = "1";
      }

      if (trigger.className.indexOf("popover-trigger") > -1) {
        var popover = trigger.children[0];
        if (popover.hasAttribute("style") && popover.style.visibility === "visible") hideTarget(popover);
        else {
          var items = document.querySelectorAll("." + popover.className);
          if (items.length > 0) {
            for (var i in items) {
              if (typeof items[i] === "object") {
                hideTarget(items[i]);
              }
            }
          }
          showTarget(popover);
        }
      } else if (trigger.className.indexOf("close") > -1) hideTarget(trigger.parentElement);
    }
  }
  // ANALYTICS FUNCTIONS
  getSocialMediaNameViaClassName(tag){
    var result = tag.className, // return string
      prefix = "fs-icons_"; // prefix for the social media classname
    // string calculation variables
    var index = result.indexOf(prefix), // index number for the first character
      ln = result.length, // index number for the last character
      diff = prefix.length; // prefix length, used for calculation

    return (result = result.slice((index + diff), ln));
  }
  // analytics tracking
  trackLink(target) {
    if (typeof window.utag !== "undefined") {
      var that = this;

      var socialMedia = that.getSocialMediaNameViaClassName(target);
      var url = decodeURIComponent(that.options.url);
      var utmSource = 'share_';

      switch(socialMedia) {
        case "facebook":
          utmSource += 'fb';
          break;
        case "twitter":
          utmSource += 'tw';
          break;
        case "google":
          utmSource += 'g';
          break;
        case "email":
          utmSource += 'm';
          break;
        default:
          break;
      }
      if (typeof PARSELY !== "undefined" && typeof PARSELY.beacon === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
        var utmObj = {
          'utm_campaign' : 'share_buttons',
          'utm_medium' : 'fscom',
          'utm_source' : utmSource,
          'utm_content' : 'original_share' 
        }

        var trackObj = {
            'url': TrackingUtils.addTrackingQuery(utmObj,url),
            js: 1 // flag indicating that this is a dynamic event, keep it "1"
        };

        PARSELY.beacon.trackPageView(trackObj); 
          
      }

      // // "utag"-based analytics tracking (DISABLED)
      // originParam = (that.options.url.indexOf("?") > -1) ? "&origin=" : "?origin=";

      // var utagFilename = url + originParam + socialMedia;

      // window.utag.link({
      //   'filename': utagFilename
      // });
    }
  }
}

export default SocialBar;


// WEBPACK FOOTER //
// ./assets/components/SocialBar/SocialBar.js